import imageCreditsList from './images'
const [asteroidImage, chessboardImage,itToolsImage] = imageCreditsList

const portfolioData = [
    {
        id: 1,
        title: `Potentially Hazardous Asteroid`,
        description: `The PHA (Potentially Hazardous Asteroid) Tracker is a full-stack monitoring application designed to ingest asteroid approach data from the NASA NeoWs API, 
        persist it in a secure database, and display critical close-approach information to the user via a responsive React frontend.`,
        tags: [`React`, `Redux (Custom HOC)`, `Express.js`, `MongoDB`],
        githubUrl: `https://github.com/ABearish/PHA`,
        liveUrl: `#`,
        imageUrl: `${asteroidImage.imageUrl || asteroidImage.fallbackPath}`,
    },
    {
        id: 2,
        title: `Sudoku Solver`,
        description: `Sudoku Solver is an interactive web application that allows users to design, validate, and find the unique solution to custom Sudoku puzzles.\r`,
        tags: [`React`, `Tailwind CSS`, 'Backtracking Algorithm'],
        githubUrl: `https://github.com/ABearish/sudokuSolver`,
        liveUrl: `#`,
        imageUrl: `${chessboardImage.imageUrl || chessboardImage.fallbackPath}`,
    },
    {
        id: 3,
        title: `Automation IT Tools`,
        description: `A Suite of automation IT Tools`,
        tags: [`Python`, `Automation IT Tools`, `Bash`, `Defensive Coding`],
        githubUrl: `https://github.com/ABearish/Automation_Tools`,
        liveUrl: `#`,
        imageUrl: `${itToolsImage.imageUrl || itToolsImage.fallbackPath}`,
    },
];


export default portfolioData